import { apiRequest } from '../api/client';
import { API_ENDPOINTS, withParams } from '../config/apis';

export type B2BState = 'WAITING' | 'COMPLETED';
export type B2BType = 'TIMING_AGENCY' | 'GOODS' | 'HYBRID_PACKAGE' | 'SECURITY_USB';

export type B2BPost = {
  id: number;
  depth: number;
  writer: string;
  organization: string | null;
  email: string | null;
  title: string;
  content: string | null;
  type: B2BType;
  state: B2BState;
  secret: boolean;
  createdAt: string;
};

export type B2BListItem = B2BPost & {
  answerWriterEmail?: string;
};

export type B2BAnswer = {
  id: number;
  b2bId: number;
  writerEmail: string;
  title: string;
  content: string | null;
  answeredAt: string;
};

export type B2BDetail = {
  id: number;
  writer: string;
  organization: string | null;
  email: string | null;
  title: string;
  content: string;
  type: B2BType;
  state: B2BState;
  secret: boolean;
  createdAt: string;
  answer: B2BAnswer | null;
};

type B2BListResponse = {
  b2bs: B2BPost[];
};

type B2BAnswerRequest = {
  writerEmail: string;
  answer: string;
};

type B2BDeleteRequest = {
  b2bIds: number[];
};

function toB2BListItems(b2bs: B2BPost[]) {
  const questions: B2BListItem[] = [];

  b2bs.forEach((b2b) => {
    if (b2b.depth === 0) {
      questions.push(b2b);
      return;
    }

    const lastQuestion = questions.at(-1);

    if (lastQuestion) {
      lastQuestion.answerWriterEmail = b2b.writer;
    }
  });

  return questions;
}

export const b2bService = {
  list: (keyword = '') =>
    apiRequest<B2BListResponse>(API_ENDPOINTS.b2bList, {
      query: { keyword: keyword.trim() || undefined },
    }).then((response) => toB2BListItems(response.b2bs)),

  detail: (b2bId: number) =>
    apiRequest<B2BDetail>(withParams(API_ENDPOINTS.b2bDetail, { b2bId })),

  createAnswer: (b2bId: number, body: B2BAnswerRequest) =>
    apiRequest<B2BAnswer, B2BAnswerRequest>(withParams(API_ENDPOINTS.b2bAnswerCreate, { b2bId }), { body }),

  updateAnswer: (b2bId: number, body: B2BAnswerRequest) =>
    apiRequest<B2BAnswer, B2BAnswerRequest>(withParams(API_ENDPOINTS.b2bAnswerUpdate, { b2bId }), { body }),

  delete: (b2bId: number) =>
    apiRequest<void, B2BDeleteRequest>(API_ENDPOINTS.b2bDelete, { body: { b2bIds: [b2bId] } }),
};
